import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { SxProps, Theme } from '@mui/material/styles';

const customStyles: Record<string, SxProps<Theme>> = {
  backdrop: {
    zIndex: (theme: Theme) => theme.zIndex.drawer + 999,
    color: '#fff',
  },
};

interface LoadingBackdropProps {
  invisibleBackdrop?: boolean;
}

export function LoadingBackdrop({ invisibleBackdrop = true }: LoadingBackdropProps) {
  return (
    <Backdrop
      sx={customStyles.backdrop}
      open={true}
      invisible={invisibleBackdrop}
      transitionDuration={0}
    >
      <CircularProgress color='primary' />
    </Backdrop>
  );
}
